<div class="d-flex flex-column gap-2 w-100 symptome-block" *ngIf="symptome">
    <div class="d-flex justify-content-between gap-3 w-100 pe-4">
        <div>{{symptome.label}}</div>
        <div class="hide-on-pdf" *ngIf="symptome.freeText">
            <div (click)="fnShowFreeText()" class="anmerkung-icon" [class.active]="symptome.showFreeText">
                <img src="/pep/images/icons/Anmerkung Icon.svg" />
                <img src="/pep/images/icons/Anmerkung Icon - Active.svg" />
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-start w-100">
        <div class="symptome-box" [style.backgroundColor]="getSymptomesBG()"></div>
        <div class="symptome-graph">
            <div class="symptome-value lower-value" [class.active]="getIsLowerValue()" [style.backgroundColor]="getIsLowerValue()?getSymptomesBG():null" [style.left.%]="getLowerValueLeft()">
                <div class="symptome-text">{{getLowerValue()}}</div>
            </div>
            <div class="symptome-value upper-value" [class.active]="getIsUpperValue()" [class.equal]="getIsEqualValue()" [style.backgroundColor]="(getIsUpperValue() || getIsEqualValue())?getSymptomesBG():null" [style.left.%]="getUpperValueLeft()">
                <div class="symptome-text">{{getUpperValue()}}</div>
            </div>
            <div class="symptome-slider" [style.left.%]="getLowerValueLeft()" [style.width.%]="getUpperValueLeft() - getLowerValueLeft()" [style.backgroundColor]="getSymptomesBG()"></div>
        </div>
    </div>
    <div class="hide-on-pdf" *ngIf="symptome.showFreeText && symptome.freeText">
        <div class="quill-view" [innerHTML]="symptome.freeText"></div>
    </div>
</div>
